'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useState } from 'react';
import type { Swiper as SwiperType } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { UsageStep } from '@/app/cc/_component/ui/section/AnsimUsage/AnsimUsage';
import styles from '@/app/cc/_component/ui/section/AnsimUsage/AnsimUsage.module.scss';
import UsageTabCard from '@/app/cc/_component/ui/section/AnsimUsage/UsageTabCard';
import { useGetDealType } from '@/app/cc/_stores/useDealTypeStore';
import { sendGA } from '@/app/cc/_util/sendGA';
interface AnsimUsageCardsProps {
  usageSteps: UsageStep[];
  selectedTab: number;
  isBeforeContract: boolean;
  setSelectedTab: (tab: number) => void;
  swiperRef: React.RefObject<SwiperType | null>;
}
export default function AnsimUsageCards(t0) {
  const $ = _c(39);
  const {
    swiperRef,
    usageSteps,
    selectedTab,
    isBeforeContract,
    setSelectedTab
  } = t0;
  const [isSwiperLocked, setIsSwiperLocked] = useState(false);
  const dealType = useGetDealType();
  const arrowIconSrc = dealType === "rent" ? "/cc/image/icon_rightArrow_green.svg" : "/cc/image/icon_rightArrow_blue.svg";
  let T0;
  let t1;
  let t10;
  let t11;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== arrowIconSrc || $[1] !== isBeforeContract || $[2] !== isSwiperLocked || $[3] !== selectedTab || $[4] !== setSelectedTab || $[5] !== swiperRef || $[6] !== usageSteps) {
    const handleSelectTab = index => {
      setSelectedTab(index);
      swiperRef.current?.slideTo(index);
      sendGA(isBeforeContract ? "beforeUsageStep" : "afterUsageStep");
    };
    let t12;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = swiper => {
        setIsSwiperLocked(swiper.isLocked);
      };
      $[19] = t12;
    } else {
      t12 = $[19];
    }
    const syncSwiperLock = t12;
    t10 = styles.usageCards;
    t11 = isSwiperLocked;
    T0 = Swiper;
    t1 = styles.usageSwiper;
    t2 = 0;
    t3 = true;
    t4 = "auto";
    if ($[20] !== swiperRef) {
      t5 = swiper_0 => {
        swiperRef.current = swiper_0;
        syncSwiperLock(swiper_0);
      };
      $[20] = swiperRef;
      $[21] = t5;
    } else {
      t5 = $[21];
    }
    t6 = syncSwiperLock;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = () => setIsSwiperLocked(true);
      t8 = () => setIsSwiperLocked(false);
      $[22] = t7;
      $[23] = t8;
    } else {
      t7 = $[22];
      t8 = $[23];
    }
    t9 = usageSteps.map((step, index_0) => {
      const state = index_0 === selectedTab && "selected" || index_0 < selectedTab && "visited" || "default";
      const arrowIcon = index_0 < selectedTab ? arrowIconSrc : "/cc/image/icon_rightArrow_default.svg";
      return <SwiperSlide key={step.tabNumber} className={styles.usageSwiperSlide}><UsageTabCard tabNumber={step.tabNumber} tabContent={step.tabContent} state={state} onClick={() => handleSelectTab(index_0)} />{index_0 < usageSteps.length - 1 && <div className={styles.usageArrow}><Image src={arrowIcon} alt="step_arrow" width={32} height={32} /></div>}</SwiperSlide>;
    });
    $[0] = arrowIconSrc;
    $[1] = isBeforeContract;
    $[2] = isSwiperLocked;
    $[3] = selectedTab;
    $[4] = setSelectedTab;
    $[5] = swiperRef;
    $[6] = usageSteps;
    $[7] = T0;
    $[8] = t1;
    $[9] = t10;
    $[10] = t11;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    T0 = $[7];
    t1 = $[8];
    t10 = $[9];
    t11 = $[10];
    t2 = $[11];
    t3 = $[12];
    t4 = $[13];
    t5 = $[14];
    t6 = $[15];
    t7 = $[16];
    t8 = $[17];
    t9 = $[18];
  }
  let t12;
  if ($[24] !== T0 || $[25] !== t1 || $[26] !== t2 || $[27] !== t3 || $[28] !== t4 || $[29] !== t5 || $[30] !== t6 || $[31] !== t7 || $[32] !== t8 || $[33] !== t9) {
    t12 = <T0 className={t1} spaceBetween={t2} watchOverflow={t3} slidesPerView={t4} onSwiper={t5} onResize={t6} onLock={t7} onUnlock={t8}>{t9}</T0>;
    $[24] = T0;
    $[25] = t1;
    $[26] = t2;
    $[27] = t3;
    $[28] = t4;
    $[29] = t5;
    $[30] = t6;
    $[31] = t7;
    $[32] = t8;
    $[33] = t9;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== t10 || $[36] !== t11 || $[37] !== t12) {
    t13 = <div className={t10} data-swiper-locked={t11}>{t12}</div>;
    $[35] = t10;
    $[36] = t11;
    $[37] = t12;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  return t13;
}